export default __webpack_public_path__ + "static/media/step-2.4ff60260.png";